module.exports = __webpack_public_path__ + "img/care@2x.8b0e853.jpg";